<template>
  <v-container class="not-found">
    <v-icon :size="iconSize">
      {{ icon }}
    </v-icon>
    <div class="text-center">
      <h1>
        404
      </h1>
      <p>
        {{ message }}
      </p>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-emoticon-sad-outline'
    },
    iconSize: {
      type: Number,
      default: 180
    }
  }
}
</script>

<style lang="css" scoped>
.not-found {
  width: 100%;
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 7.5%;
  align-items: center;
  justify-content: center;
}
</style>
